// extracted by mini-css-extract-plugin
export default {"image":"RegistrationDisabledUserScreen_image__xZigs","body":"RegistrationDisabledUserScreen_body__NE0Fl"};